export default "__VITE_ASSET__28bAtbkw__"